/** Phone / mobile on a new account: country dial code + digits, nothing else. */

export function nationalDigits(value, maxLength) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!maxLength || maxLength < 1) return digits;
  return digits.slice(0, maxLength);
}

/** `+` plus country and national digits. Empty when there is no national number. */
export function composeStoredPhone(dialCode, national) {
  const digits = String(national || '').replace(/\D/g, '');
  if (!digits) return '';
  const code = String(dialCode || '').replace(/\D/g, '');
  return code ? `+${code}${digits}` : digits;
}

export function splitStoredPhone(value, countryCodes = []) {
  const raw = String(value || '').trim();
  if (!raw) return { dialCode: '', national: '' };
  const compact = raw.startsWith('+') ? `+${raw.replace(/\D/g, '')}` : raw.replace(/\D/g, '');
  if (compact.startsWith('+')) {
    const sorted = [...countryCodes].sort((a, b) => b.dialCode.length - a.dialCode.length);
    const match = sorted.find((entry) => compact.startsWith(entry.dialCode));
    if (match) {
      return {
        dialCode: match.dialCode,
        national: compact.slice(match.dialCode.length),
      };
    }
  }
  return { dialCode: '', national: compact.replace(/\D/g, '') };
}

export function dialCodeForCountryName(name, countryCodes = []) {
  const normalized = String(name || '').trim().toLowerCase();
  if (!normalized) return '';
  const byName = countryCodes.find((entry) => entry.country.toLowerCase() === normalized);
  if (byName) return byName.dialCode;
  const byIso = countryCodes.find((entry) => entry.iso2.toLowerCase() === normalized);
  return byIso ? byIso.dialCode : '';
}

export function phoneLengthHint(range) {
  if (!range) return 'Choose a country code, then enter digits only';
  if (range.minLength === range.maxLength) {
    return `${range.minLength} digits for this country, no spaces or symbols`;
  }
  return `${range.minLength}–${range.maxLength} digits for this country, no spaces or symbols`;
}
